import {InputNumberProps} from "antd/es/input-number";
import {Box, Text} from "grommet";
import {InputNumber} from "antd";
import {TokenSelect} from "./TokenSelect";
import React from "react";
import {SwapSideState, SwapSideType} from "./SwapWidget";
import {NativeCurrency, Token} from "@uniswap/sdk-core";

type ValueType = string | number | undefined | null

const formatterHelper = (value: ValueType) => {
  const valueStr = (value || '').toString()
  const [decimalPart, fractionalPart = ''] = valueStr.split('.')
  const decimalFormatted = `${decimalPart}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  const fractionalFormatted = fractionalPart ? `.${fractionalPart}` : ''
  return decimalFormatted + fractionalFormatted
}

const parserHelper = (value: ValueType) => `${value}`.replace(/\$\s?|(,*)/g, '')

export interface SwapSideProps {
  type: SwapSideType
  data: SwapSideState
  onChangeAmount: (value: string) => void
  onChangeToken: (token: Token | NativeCurrency) => void
}

export const SwapSide = (props: SwapSideProps) => {
  const {
    type,
    data: {
      token,
      amount,
      balance
    },
    onChangeAmount,
    onChangeToken
  } = props

  const inputProps: InputNumberProps = {
    className: 'swap_number_input',
    controls: false,
    autoFocus: true,
    value: amount,
    min: 0,
    // max: balance,
    formatter: formatterHelper,
    parser: parserHelper,
    style: {
      width: '100%',
      border: 'none',
      background: 'transparent',
      fontSize: '52px',
    },
    onChange: (value) => {
      onChangeAmount(value?.toString() || '')
    }
  }

  const onSelectToken = (token: Token | NativeCurrency) => {
    onChangeToken(token)
  }

  return <Box
    width={'620px'}
    height={'170px'}
    direction={'row'}
    justify={'between'}
    background={'rgba(255, 255, 255, 0.22)'}
    round={'18px'}
    pad={'28px 20px'}
    style={{ position: 'relative' }}
  >
    <Box>
      <Box>
        <Text size={'18px'} weight={'bold'}>
          {type === 'pay' ? 'You pay' : 'You receive'}
        </Text>
      </Box>
      <Box width={'360px'}>
        <InputNumber {...inputProps} />
      </Box>
    </Box>
    <Box
      align={'end'}
      justify={'center'}
    >
      <TokenSelect token={token} onSelect={onSelectToken} />
      {token &&
          <Box style={{ position: 'absolute', bottom: '24px', right: '32px' }}>
              <Text>
                  Balance: {(+balance).toFixed(2)}
              </Text>
          </Box>
      }
    </Box>
  </Box>
}
